export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const doctorImage = require("../assets/illustration-register-copy@3x.png")
